import { environment } from '../../../environments/environment';

export interface RuntimeConfig {
  API_BASE: string;
}

const RUNTIME_CONFIG_URL = '/runtime-config.json';

const runtimeConfig: RuntimeConfig = {
  API_BASE: '',
};

export function setRuntimeConfig(config: Partial<RuntimeConfig>): void {
  runtimeConfig.API_BASE = (config.API_BASE ?? runtimeConfig.API_BASE).trim();
}

export function getRuntimeConfig(): RuntimeConfig {
  return runtimeConfig;
}

export async function loadRuntimeConfig(): Promise<void> {
  try {
    const response = await fetch(RUNTIME_CONFIG_URL, { cache: 'no-store' });
    if (!response.ok) {
      console.error(`Runtime config not found at ${RUNTIME_CONFIG_URL} (status: ${response.status}).`);
      return;
    }

    const config = (await response.json()) as Partial<RuntimeConfig>;
    setRuntimeConfig(config);
    if (!getRuntimeConfig().API_BASE) {
      console.error('Runtime config loaded, but API_BASE is empty.');
    }
  } catch {
    console.error('Runtime config could not be loaded.');
  }
}

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '');
}

export function getApiBaseUrl(resource: string): string {
  const normalizedBase = trimTrailingSlash(getRuntimeConfig().API_BASE);
  if (!normalizedBase) {
    throw new Error('API_BASE is not configured at runtime.');
  }

  return `${normalizedBase}/${environment.API_VERSION}/${resource}`;
}


